(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pe-featured-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pe-featured-collection')) {
    customElements.define('pe-featured-collection', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.init());
      }
      init() {
        this.track = this.querySelector('.pe-fc__track');
        this.dots = this.querySelector('.pe-fc__dots');
        if (!this.track || !this.dots) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.track.addEventListener('scroll', () => this.update(), { passive: true, signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || this.dots.hidden) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          let next = this.active;
          if (event.key === 'ArrowRight') next += rtl ? -1 : 1;
          else if (event.key === 'ArrowLeft') next += rtl ? 1 : -1;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.pages.length - 1;
          else return;
          event.preventDefault();
          this.go(next);
        }, { signal });
        this.dots.addEventListener('click', event => {
          const button = event.target.closest('button[data-page]');
          if (button) this.go(Number(button.dataset.page));
        }, { signal });
        this.observer = new ResizeObserver(() => this.build());
        this.observer.observe(this.track);
        this.build();
      }
      build() {
        const cards = Array.from(this.track.querySelectorAll('.pe-fc__card'));
        const max = this.track.scrollWidth - this.track.clientWidth;
        const mobile = matchMedia('(max-width: 749px)').matches;
        this.pages = [0];
        if (mobile && max > 2 && cards.length) {
          const first = cards[0].getBoundingClientRect();
          cards.slice(1).forEach(card => {
            const distance = Math.abs(card.getBoundingClientRect().left - first.left);
            const target = Math.min(distance, max);
            if (target - this.pages[this.pages.length - 1] > 2) this.pages.push(target);
          });
        }
        // Keep existing buttons during same-page-count resize so focus isn't lost.
        if (this.dots.children.length !== this.pages.length) {
          this.dots.replaceChildren(...this.pages.map((_, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'pe-fc__dot';
            button.dataset.page = index;
            button.setAttribute('aria-label', `${this.dots.dataset.pageLabel} ${index + 1}`);
            button.setAttribute('aria-controls', this.track.id);
            return button;
          }));
        }
        this.dots.hidden = this.pages.length < 2;
        this.update();
      }
      go(index) {
        const target = Math.max(0, Math.min(index, this.pages.length - 1));
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.track.scrollTo({ left: this.pages[target] * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      update() {
        if (!this.pages) return;
        const position = Math.abs(this.track.scrollLeft);
        this.active = this.pages.reduce((best, value, index) => Math.abs(value - position) < Math.abs(this.pages[best] - position) ? index : best, 0);
        Array.from(this.dots.children).forEach((button, index) => button.setAttribute('aria-current', String(index === this.active)));
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.abort) this.abort.abort();
        if (this.observer) this.observer.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
